import React from "react";
import { Center, CircularProgress } from "@chakra-ui/react";

const LoadingCircular = ({ size, ...props }: any) => {
  return (
    <Center w="full">
      <CircularProgress
        size={size || "30px"}
        isIndeterminate
        color="brandOrange.500"
        {...props}
      />
    </Center>
  );
};

export default LoadingCircular;
